/* ==========================================================================
   Voltix — Favoris / Wishlist (localStorage, sans app tierce)
   ========================================================================== */
(function () {
  var STORAGE_KEY = 'voltixWishlist';
  var HEART_ICON =
    '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.6-10-9.2C.4 8.4 2 4.5 5.8 4c2-.3 3.9.7 5 2.3.9-1.6 2.9-2.6 5-2.3C19.9 4.5 21.6 8.4 20 11.8 17.5 16.4 12 21 12 21z"/></svg>';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().some(function (p) {
      return p.handle === handle;
    });
  }

  function toggleWishlist(product, btn) {
    var list = getWishlist();
    var idx = list.findIndex(function (p) {
      return p.handle === product.handle;
    });
    var nowActive;
    if (idx > -1) {
      list.splice(idx, 1);
      nowActive = false;
    } else {
      list.unshift(product);
      nowActive = true;
    }
    saveWishlist(list);
    if (btn) btn.classList.toggle('is-active', nowActive);
    document.querySelectorAll('.voltix-wishlist-btn[data-handle="' + product.handle + '"]').forEach(function (el) {
      el.classList.toggle('is-active', nowActive);
    });
    updateHeaderBadge();
    renderDrawerList();
    return nowActive;
  }

  function extractHandleFromUrl(url) {
    var match = url.match(/\/products\/([^\/\?#]+)/);
    return match ? match[1] : null;
  }

  /* --- Injecte un cœur sur chaque carte produit --- */
  function injectHeartButtons() {
    var cards = document.querySelectorAll('.card-wrapper, .product-card');
    cards.forEach(function (card) {
      if (card.querySelector('.voltix-wishlist-btn')) return; // déjà fait

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var handle = extractHandleFromUrl(link.href);
      if (!handle) return;

      var img = card.querySelector('img');
      var titleEl = card.querySelector('.card__heading, .product-card__title, [class*="title"]');
      var priceEl = card.querySelector('.price, [class*="price"]');

      var product = {
        handle: handle,
        title: titleEl ? titleEl.textContent.trim() : (link.getAttribute('aria-label') || handle),
        image: img ? (img.currentSrc || img.src) : '',
        price: priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '',
        url: link.href
      };

      card.style.position = 'relative';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'voltix-wishlist-btn';
      btn.setAttribute('data-handle', handle);
      btn.setAttribute('aria-label', 'Ajouter aux favoris');
      btn.innerHTML = HEART_ICON;

      if (isInWishlist(handle)) {
        btn.classList.add('is-active');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(product, btn);
      });

      card.appendChild(btn);
    });
  }

  /* --- Icône favoris + compteur dans le header --- */
  function injectHeaderIcon() {
    if (document.querySelector('.voltix-wishlist-header-btn')) return;

    var cartIcon = document.querySelector('[href="/cart"], .cart-icon, #cart-icon-bubble');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'voltix-wishlist-header-btn';
    btn.setAttribute('aria-label', 'Voir mes favoris');
    btn.innerHTML = HEART_ICON + '<span class="voltix-wishlist-count"></span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });

    if (cartIcon && cartIcon.parentNode) {
      cartIcon.parentNode.insertBefore(btn, cartIcon);
    } else {
      var header = document.querySelector('.header, header.shopify-section');
      if (header) {
        header.appendChild(btn);
      }
    }

    updateHeaderBadge();
  }

  function updateHeaderBadge() {
    var list = getWishlist();
    var headerBtn = document.querySelector('.voltix-wishlist-header-btn');
    if (!headerBtn) return;
    var countEl = headerBtn.querySelector('.voltix-wishlist-count');
    headerBtn.classList.toggle('has-items', list.length > 0);
    if (countEl) {
      countEl.textContent = list.length;
      countEl.classList.toggle('is-visible', list.length > 0);
    }
  }

  /* --- Panneau latéral --- */
  var drawerEl, backdropEl;

  function buildDrawer() {
    if (drawerEl) return;

    backdropEl = document.createElement('div');
    backdropEl.className = 'voltix-wishlist-drawer__backdrop';
    backdropEl.addEventListener('click', closeDrawer);

    drawerEl = document.createElement('div');
    drawerEl.className = 'voltix-wishlist-drawer';
    drawerEl.innerHTML =
      '<div class="voltix-wishlist-drawer__header">' +
        '<h3>Mes favoris</h3>' +
        '<button type="button" class="voltix-wishlist-drawer__close" aria-label="Fermer">&times;</button>' +
      '</div>' +
      '<div class="voltix-wishlist-drawer__list"></div>' +
      '<div class="voltix-wishlist-drawer__footer">' +
        '<a href="/collections/all">Continuer mes achats</a>' +
      '</div>';

    drawerEl.querySelector('.voltix-wishlist-drawer__close').addEventListener('click', closeDrawer);

    document.body.appendChild(backdropEl);
    document.body.appendChild(drawerEl);
  }

  function renderDrawerList() {
    if (!drawerEl) return;
    var listEl = drawerEl.querySelector('.voltix-wishlist-drawer__list');
    var items = getWishlist();

    if (!items.length) {
      listEl.innerHTML = '<div class="voltix-wishlist-drawer__empty">Aucun favori pour l\'instant.<br>Clique sur le cœur d\'un produit pour l\'ajouter ici.</div>';
      return;
    }

    listEl.innerHTML = '';
    items.forEach(function (p) {
      var row = document.createElement('div');
      row.className = 'voltix-wishlist-drawer__item';
      row.innerHTML =
        (p.image ? '<img src="' + p.image + '" alt="">' : '') +
        '<div class="voltix-wishlist-drawer__item-info">' +
          '<a class="voltix-wishlist-drawer__item-title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="voltix-wishlist-drawer__item-price">' + (p.price || '') + '</div>' +
        '</div>' +
        '<button type="button" class="voltix-wishlist-drawer__item-remove" aria-label="Retirer">&times;</button>';

      row.querySelector('.voltix-wishlist-drawer__item-remove').addEventListener('click', function () {
        toggleWishlist(p, null);
      });

      listEl.appendChild(row);
    });
  }

  function openDrawer() {
    buildDrawer();
    renderDrawerList();
    drawerEl.classList.add('is-open');
    backdropEl.classList.add('is-open');
  }

  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    backdropEl.classList.remove('is-open');
  }

  function init() {
    injectHeartButtons();
    injectHeaderIcon();

    // Réinjecte les cœurs si des cartes sont chargées dynamiquement (scroll infini, filtres AJAX, quick view, etc.)
    var observer = new MutationObserver(function () {
      injectHeartButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
